<template>
	<div class="sk-radio" :class="{ disabled: readonly }" @click="updateModel">
		<input
			type="radio"
			v-model="model"
			:checked="model == option"
			:value="option"
			:disabled="disabled"
		/>
		<span class="checkmark">
			<span class="checkmark-fill"></span>
		</span>
	</div>
</template>

<style>
.sk-radio-group {
	display: flex;
	align-items: center;
}

.sk-radio + span {
	font-weight: 600;
	color: var(--sk-grey2);
}

.sk-radio.selected + span {
	color: var(--gR-base-90);
}
</style>

<style scoped>
.sk-radio {
	display: block;
	position: relative;
	cursor: pointer;
	font-size: 22px;
	user-select: none;
	width: 30px;
	height: 30px;
	margin-right: 30px;
}

.sk-radio.disabled {
	pointer-events: none;
}

.sk-radio input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

.checkmark {
	width: 100%;
	height: 100%;
	background-color: var(--gR-white);
	border: 1px solid var(--sk-grey2);
	border-radius: 50%;
	display: flex;
	align-items: center;
}

.sk-radio:hover input ~ .checkmark {
	opacity: 0.8;
}

.sk-radio input:disabled ~ .checkmark {
	opacity: 0.5;
}

.sk-radio input:checked ~ .checkmark {
	background-color: var(--gR-white);
	border: 1px solid var(--gR-base-90);
}

.sk-radio .checkmark-fill {
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	position: absolute;
	width: 0;
	height: 0;
	border-radius: 50%;
	background: var(--gR-base-90);
	transition: width 0.15s ease-in, height 0.15s ease-in;
}

.sk-radio input:checked ~ .checkmark .checkmark-fill {
	width: 60%;
	height: 60%;
}
</style>

<script>
export default {
	name: "SkRadio",
	props: {
		checked: Boolean,
		disabled: Boolean,
		readonly: Boolean,
		option: null,
		value: null
	},
	computed: {
		model: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit("input", val)
			}
		}
	},
	methods: {
		updateModel() {
			this.model = this.option
		}
	}
}
</script>